var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"js-coupon-button",attrs:{"data-t":"8.5","data-coupon-id":_vm.model.id,"data-coupon-url":_vm.url,"data-product-id":_vm.productId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }